import Vue from 'vue';
import App from './PublishingInfo.vue';




window.Apps = window.Apps || {};
Apps.initPublishingInfo = function(ascxCtrlId, neverPublish, initialTranslations) {
  if($('#publish-info-app-' + ascxCtrlId).length > 0){
    var data = {
      neverPublish
      ,initialTranslations
    }
    new Vue({
      el: '#publish-info-app-' + ascxCtrlId
      ,data
      ,render: h => h(App)
    })
  }
}
